/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_FrenchInputs */



/**
* | output |
* | --- |
* | "French" |
*
* @param {Speechmatics_Target_Language_FrenchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_french = /** @type {((inputs?: Speechmatics_Target_Language_FrenchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_FrenchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Francais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Französisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("francese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Французский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Francés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("法语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フランス語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेंच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Francês")
	return /** @type {LocalizedString} */ ("French")
});